import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import CloseIcon from "@mui/icons-material/Close";
import {
  Avatar,
  Box,
  DialogContent,
  DialogTitle,
  IconButton,
  ClickAwayListener,
} from "@mui/material";
import List from "@mui/material/List";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import { makeStyles } from "../../tss";
import { useNavigate } from "react-router-dom";
import { INVOICEPREVIEW_ROUTE, NOTIFICATION_ROUTE } from "../../constants/RoutePaths";
import { Typography } from "antd";
import { styled } from "@mui/material/styles";
import { authHeader } from "../../comman/mainfunction";
import { GET_NOTIFICATION_URL, SAVE_NOTIFICATION_DETAILS } from "../../comman/url";
import { getUserId } from "../../comman/function";
import API from "../../constants/API";
import moment from "moment";
import Loader from "../../comman/Loader";

const useStyles = makeStyles((_theme: any) => ({
  BootstrapDialog: {
    width: 0,
  },
  canceldialog: {
    border: "1px solid #EC7C37 !important",
    color: "#EC7C37 !important",
    margin: "8px",
    textTransform: "none !important",
    padding: "8px 16px",
    marginRight: "12px",

    "&:hover": {
      border: "1px solid #EC7C37 !important",
      backgroundColor: "#F6F6F680 !important",
      color: "#EC7C37 !important",
    },
  },
  submitdialog: {
    backgroundColor: " #EC7C37 !important",
    color: "white !important",
    margin: "8px",
    padding: "8px 16px",
    textTransform: "none !important",
    "&:hover": {
      backgroundColor: "#D25D15 !important",
      color: "white !important",
    },
  },
  nativedrop: {
    padding: "16.5px 14px",
  },
  smallseperate: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
  optiontext: {
    textTransform: "capitalize",
  },
  boxhov: {
    "&:hover": {
      color: "#f0f1f5",
      border: "none",
      backgroundColor: "none",
      fontWeight: "18px",
      fontSize: "large",
    },
  },
  viewbtn: {
    color: "#ec7c37",
    border: "none",
    backgroundColor: "none",
    fontWeight: "18px",
    fontSize: "large",
    display: "flex",
    alignItems: "center",
    columnGap: "10px",
    "&:hover": {
      color: "#14142A !important",
      border: "#14142A !important",
      backgroundColor: "#00000021 !important",
      fontWeight: "18px",
      fontSize: "large",
      // cursor: "pointer",
    },
  },
  divCon: {
    width: "70%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flexStart",
    overflow: "hidden",
  },
  downbn: {
    // backgroundColor: "#ec7c37 !important",
    boxShadow: "none !important",
    textTransform: "none !important",
    fontSize: "12px !important",
    border: "1px solid #ec7c37 !important",
    "&:hover": {
      color: "#ec7c37 !important",
      fontSize: "12px !important",
      border: "1px solid #ec7c37 !important",
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
      cursor: "pointer",
    },
  },
}));
const Demo = styled("div")(({ theme }: any) => ({
  backgroundColor: theme.palette.background.paper,
}));
export default function NotifyPopup(props) {
  const { openList, setFlag } = props;
  const [, setCompleteList] = useState();
  const [notcompleteList, setNotCompleteList] = useState();
  const [, setCount] = useState();
  const [loading, setLoading] = useState(false);
  const styleclasses = useStyles();
  const history = useNavigate();

  const getNotificationDetails = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_NOTIFICATION_URL,

      headers: authHeader(),
      params: {
        userId: getUserId(),
      },
    };

    try {
      const response = await API(config);
      //  const { status, data } = response.data;
      const { status, messageCount, readedMessages, unreadedMessages } = response.data;

      if (status === "Success") {
        setCompleteList(readedMessages);
        setNotCompleteList(unreadedMessages);
        setCount(messageCount[0]?.totalCount || 0);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNotificationDetails();
  }, []);

  useEffect(() => {}, [notcompleteList]);

  const localdata = new Date();
  const dateAsString = localdata.toString();
  const _timezone = dateAsString.match(/\(([^\)]+)\)$/)[1];

  const markAsRead = async (notificationId) => {
    try {
      const config = {
        method: "POST",
        url: SAVE_NOTIFICATION_DETAILS,
        headers: authHeader(),
        data: {
          notificationDetailsId: notificationId,
          userId: getUserId(),
          isRead: 1,
        },
      };
      await API(config);
    } catch (error) {
      console.error("Failed to mark notification as read:", error);
    }
  };

  const handleClick = (event) => {
    const invoiceID = event.currentTarget.dataset.id;
    const notificationId = event.currentTarget.dataset.notificationid;

    // Mark notification as read
    if (notificationId) {
      markAsRead(notificationId);
    }

    history(`${INVOICEPREVIEW_ROUTE}/${invoiceID}`, {
      state: { locationChange: true },
    });
    openList();
  };
  const BootstrapDialogTitle = (props) => {
    const { children, onClose, onBlur: _onBlur, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };
  const viewMoreFun = () => {
    openList();
    history(NOTIFICATION_ROUTE);
  };

  return (
    <ClickAwayListener onClickAway={() => setFlag(false)}>
      <div
        className="notpop-screen"
        style={{
          left: "160px",
          top: "210px",
          background: { pointerEvents: "none" },
        }}
        onBlur={openList}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          aria-labelledby="customized-dialog-title"
          onClose={openList}
          className={styleclasses.BootstrapDialog}
          sx={{ fontWeight: 600, color: "#14142A", fontSize: "25px" }}
        >
          Notifications
        </BootstrapDialogTitle>
        <DialogContent maxWidth="xl" sx={{ padding: "8px 24px !important", height: "300px" }}>
          <Box className="chatlist-box">
            <Demo>
              {loading && <Loader />}

              <List hover sx={{ height: "290px", overflow: "scroll" }}>
                {!loading && (!notcompleteList || notcompleteList.length === 0) && (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <Typography style={{ color: "#6E7191", fontSize: "14px" }}>
                      You're all caught up! No new notifications.
                    </Typography>
                  </Box>
                )}
                {notcompleteList &&
                  notcompleteList.map((rec, i) => {
                    const {
                      notificationDetailsId,
                      profileLogo,
                      createdDate,
                      isRead: _isRead,
                      userId: _userId,
                      firstName,
                      lastName,
                      payload,
                      invoiceId,
                    } = rec;

                    // Format name and payload for display
                    const displayName = `${firstName || ""} ${lastName || ""}`.trim();
                    const truncatedName =
                      displayName.length > 25 ? displayName.substring(0, 25) + "..." : displayName;
                    const truncatedPayload =
                      payload && payload.length > 50 ? payload.substring(0, 50) + "..." : payload;

                    return (
                      <Box
                        key={`notification-${i}`}
                        className={styleclasses.viewbtn}
                        data-id={invoiceId}
                        data-notificationid={notificationDetailsId}
                        onClick={(event) => handleClick(event)}
                        sx={{
                          borderLeft: "3px solid #EC7C37",
                          backgroundColor: "#FFF9F5",
                          mb: 1,
                          borderRadius: "0 8px 8px 0",
                          "&:hover": {
                            backgroundColor: "#FFF5F0 !important",
                          },
                        }}
                      >
                        <div className={styleclasses.divCon}>
                          <ListItemAvatar>
                            <Avatar
                              src={profileLogo}
                              sx={{
                                bgcolor: "#EC7C37",
                                width: 40,
                                height: 40,
                              }}
                            >
                              {firstName?.[0]}
                              {lastName?.[0]}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "flexStart",
                              textAlign: "start",
                            }}
                            primary={truncatedName}
                            secondary={truncatedPayload}
                            primaryTypographyProps={{
                              sx: { fontWeight: 600, fontSize: "14px", color: "#14142A" },
                            }}
                            secondaryTypographyProps={{
                              sx: { fontSize: "12px", color: "#6E7191" },
                            }}
                          />
                        </div>
                        <Box
                          sx={{
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            width: "30%",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 500,
                              fontSize: "11px",
                              color: "#A0A3BD",
                            }}
                          >
                            {moment(createdDate).fromNow()}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
              </List>
            </Demo>
          </Box>
          <br />
          <div style={{ textAlign: "end" }}>
            <Button onClick={viewMoreFun} className={styleclasses.viewbtn} variant="contained">
              View More
            </Button>
          </div>
        </DialogContent>
      </div>
    </ClickAwayListener>
  );
}
